import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

function load (component) {
  return () => System.import(`../components/${component}.vue`)
}

import DashboardProfilePatient from '../components/admin/ProfilePatient.vue';

//import { doctor } from '../config/api.js';
import { prefix } from '../config/api';

export default new VueRouter({
    mode: 'history', // disabled hastag "#" on routes
    routes: [
        {
            // only routes with countries
            path: '/:country',
            component: load('public/Base'),
            children: [
                {
                    // Route login Patient
                    path: '/',
                    name: 'login.patient',
                    component: load('public/LoginPatient'),
                    meta: {
                        forVisitors: true,
                        name: 'Login'
                    }
                },
                {
                    // Route logout
                    path: 'logout',
                    name: 'logout',
                    component: load('Logout'),
                    meta: {
                        requiresAuth: true,
                        name: 'Logout'
                    }
                },
                {
                    path: 'graphics/:id',
                    name: 'graphics',
                    component: load('admin/Graphics'),
                    meta: {
                      requiresAuth: false,
                      name: 'Graphics'
                    }
                },
                {
                    // Route dashbaord - need authentication
                    path: '/',
                    name: 'dashboard.layout',
                    component: load('admin/partials/Layout'),
                    meta: {
                        requiresAuth: true
                    },
                    children: [
                        // Route dashboard
                        {
                            path: 'dashboard',
                            name: 'dashboard',
                            component: load('admin/Dashboard'),
                            meta: { name: 'Inicio' },
                            children: []
                        },
                        {
                            path: 'prestators',
                            name: 'dashboard.prestators',
                            component: load('admin/PrestatorList'),
                            meta: { name: 'Listado Prestadores' }
                        },
                        {
                            path: 'prestator',
                            name: 'dashboard.prestator',
                            component: load('admin/PrestatorListV'),
                            meta: { name: 'Listado Prestador' }
                        },
                        {
                            path: 'sellplatform',
                            name: 'dashboard.sell.platform',
                            component: load('admin/SellPlatform'),
                            meta: { name: 'Panel de Venta' }
                        },
                        {
                            path: 'sellers_groups',
                            name: 'dashboard.sellers_groups',
                            component: load('admin/SellersGroups'),
                            meta: { name: 'Grupos de Vendedores' }
                        },
                        {
                            path: 'sellers',
                            name: 'dashboard.sellers',
                            component: load('admin/Sellers'),
                            meta: { name: 'Listado Vendedores' }
                        },
                        {
                            path: 'integrations',
                            name: 'dashboard.integrations',
                            component: load('admin/Integrations'),
                            meta: { name: 'Listado Integraciones' }
                        },
                        {
                            path: 'workers',
                            name: 'dashboard.workers',
                            component: load('admin/Workers'),
                            meta: { name: 'Listado Colaboradores' }
                        },
                        {
                            path: 'partners',
                            name: 'dashboard.partners',
                            component: load('admin/Partners'),
                            meta: { name: 'Listado Partnes' }
                        },
                        {
                            path: 'sellers/config',
                            name: 'dashboard.sellers.config',
                            component: load('admin/SellersConfig'),
                            meta: { name: 'Configuración Vendedores' }
                        },
                        {
                            path: 'prestator_plans',
                            name: 'dashboard.prestator_plans',
                            component: load('admin/PrestatorPlans'),
                            meta: { name: 'Planes de Prestadores' }
                        },
                        {
                            path: 'patients',
                            name: 'dashboard.patients',
                            component: load('admin/PatientList'),
                            meta: { name: 'Listado de Pacientes' }
                        },
                        {
                            path: 'patient_types',
                            name: 'dashboard.patient_types',
                            component: load('admin/PatientTypes'),
                            meta: { name: 'Tipos de Pacientes' }
                        },
                        {
                            path: 'reserves',
                            name: 'dashboard.reserves',
                            component: load('admin/Reserves'),
                            meta: { name: 'Reservas' }
                        },
                        {
                            path: 'bids',
                            name: 'dashboard.bids',
                            component: load('admin/Bids'),
                            meta: { name: 'Ofertas' }
                        },
                        {
                            path: 'benefits',
                            name: 'dashboard.benefits',
                            component: load('admin/Benefits'),
                            meta: { name: 'Beneficios' }
                        },
                        {
                            path: 'bonos',
                            name: 'dashboard.bonos',
                            component: load('admin/Bonos'),
                            meta: { name: 'Bonos' }
                        },
                        {
                            path: 'indicators',
                            name: 'dashboard.indicators',
                            component: load('admin/Indicators'),
                            meta: { name: 'Indicadores' }
                        },
                        {
                            path: 'financial_manager',
                            name: 'dashboard.financial_manager',
                            component: load('admin/FinancialManager'),
                            meta: { name: 'Administrador Financiero' }
                        },
                        {
                            path: 'countries',
                            name: 'dashboard.countries',
                            component: load('admin/Countries'),
                            meta: { name: 'Países' }
                        },
                        {
                            path: 'health_systems',
                            name: 'dashboard.health_systems',
                            component: load('admin/HealthSystems'),
                            meta: { name: 'Sistemas de Salud' }
                        },
                        {
                            path: 'companies',
                            name: 'dashboard.companies',
                            component: load('admin/Companies'),
                            meta: { name: 'Empresas' }
                        },
                        {
                            path: 'boxes',
                            name: 'dashboard.boxes',
                            component: load('admin/Boxes'),
                            meta: { name: 'Cajas de compensacion' }
                        },
                        {
                            path: 'roles/admin',
                            name: 'dashboard.roles',
                            component: load('admin/Roles'),
                            meta: { name: 'Roles & Permisos' }
                        },
                        {
                            path: 'roles/config/:id',
                            name: 'roles.config',
                            component: load('admin/RolesConfig'),
                            meta: { name: 'Configuración de Roles' }
                        },
                        {
                            path: 'users/admin',
                            name: 'dashboard.users',
                            component: load('admin/Users'),
                            meta: { name: 'Usuarios' }
                        },
                        {
                            path: 'medibox',
                            name: 'dashboard.medibox',
                            component: load('admin/Medibox'),
                            meta: { name: 'Medibox' }
                        },
                    ]
                },
                {
                    // Route 404
                    path: '*',
                    name: 'notfound',
                    component: load('errors/404'),
                    meta: {
                        name: 'Not Found'
                    }
                }
            ],
            meta: {
                prefix: true
            }
        },
        {
            // redirect prefix "cl" by default
            path: '/',
            redirect: '/' + prefix[0]
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js